const BROWSER_ERROR_BACKENDS = ['sentry', 'datadog'] as const;

export type BrowserErrorBackend = (typeof BROWSER_ERROR_BACKENDS)[number];

const DEFAULT_BACKENDS: readonly BrowserErrorBackend[] = ['sentry', 'datadog'];

function isBrowserErrorBackend(value: string): value is BrowserErrorBackend {
  return BROWSER_ERROR_BACKENDS.some((backend) => backend === value);
}

// Unset, blank, and unrecognized values stay on both backends. The parser runs
// in the browser, so a typo must not throw and drop the error. Callers pass the
// raw build-time string. This module does not read NEXT_PUBLIC_* or ODFE_*.
export function browserErrorBackends(raw: string | undefined): ReadonlySet<BrowserErrorBackend> {
  const trimmed = raw?.trim() ?? '';
  if (!trimmed) return new Set(DEFAULT_BACKENDS);

  const tokens = trimmed
    .split(',')
    .map((token) => token.trim())
    .filter((token) => token.length > 0);
  if (tokens.length === 0) return new Set(DEFAULT_BACKENDS);

  const backends = new Set<BrowserErrorBackend>();
  for (const token of tokens) {
    if (!isBrowserErrorBackend(token)) return new Set(DEFAULT_BACKENDS);
    backends.add(token);
  }
  return backends;
}
